import { useDisclosure } from '@/hooks';
import { Button, Tooltip } from 'antd';
import ChecklistMailSendModal from './ChecklistMailSendModal';

type Props = { disabled?: boolean; tooltipMessage?: string };

const ChecklistEmailButton: React.FC<Props> = (props) => {
  const [modalOpened, modalAction] = useDisclosure(false);

  return (
    <>
      <Tooltip
        title={
          props.disabled && (props.tooltipMessage || 'Não há veículo vinculado')
        }
      >
        <Button {...props} onClick={modalAction.open} type="primary" block>
          Enviar e-mail
        </Button>
      </Tooltip>

      <ChecklistMailSendModal open={modalOpened} onCancel={modalAction.close} />
    </>
  );
};

export default ChecklistEmailButton;
